import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import blogimag from '../Assets/Logo/Blue Logo with BG.png'

const API = "https://growthloomdigital.com/api";

const BlogDetail = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchBlog = async () => {
        try {
            const res = await fetch(`${API}/getBlogs.php`, {
                method: "POST",
            });

            const data = await res.json();

            if (data.status === "success") {
                const foundBlog = data.data.find((b) => b.id == id);
                setBlog(foundBlog);
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBlog();
    }, [id]);

    if (loading) {
        return <p className="text-center mt-10">Loading...</p>;
    }

    if (!blog) {
        return <p className="text-center mt-10">Blog not found</p>;
    }

    return (
        <div className="max-w-5xl mx-auto px-4 py-10 mt-[8%]">

            {/* TOP IMAGE (FULL WIDTH HERO) */}
            {blog.image1 && (
                <div className="w-full h-[400px] overflow-hidden rounded-xl shadow-lg">
                    {/* <img
                        src={blog.image1}
                        alt="blog"
                        className="w-full h-full object-cover"
                    /> */}
                    <img
                        // src={
                        //     blog.image1
                        //         ? `https://growthloomdigital.com/uploads/${blog.image1}`
                        //         : blogimag
                        // }
                        src={blog.image1 ? blog.image1 : blogimag}
                        alt="blog"
                        className="w-full h-full object-cover"
                    />
                </div>
            )}

            {/* TITLE */}
            <h1 className="text-3xl sm:text-4xl font-bold mt-6 text-gray-800 leading-tight">
                {blog.title}
            </h1>

            {/* DATE */}
            <p className="text-gray-500 mt-2">
                📅 {blog.created_at}
            </p>

            {/* CONTENT */}
            <div className="mt-6 text-gray-700 leading-8 text-[16px] sm:text-lg whitespace-pre-line">
                {blog.content}
            </div>

            {/* MID IMAGE (ARTICLE STYLE) */}
            {blog.image2 && (
                <div className="my-8 w-full h-[350px] overflow-hidden rounded-xl shadow-md">
                    {/* <img
            src={blog.image2}
            alt="blog"
            className="w-full h-full object-cover"
          /> */}
                    <img
                        // src={
                        //     blog.image2
                        //         ? `https://growthloomdigital.com/uploads/${blog.image2}`
                        //         : blogimag
                        // }
                        src={blog.image2 ? blog.image2 : blogimag}
                        alt="blog"
                        className="w-full h-full object-cover"
                    />
                </div>
            )}

            {/* EXTRA SPACING / END SECTION */}
            <div className="h-10"></div>

        </div>
    );
};

export default BlogDetail;